var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalixLogoReverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 16,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.4 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.79,95.32l10.11-4.2a17.85,17.85,0,0,0,4.17,7.16,17.49,17.49,0,0,0,6.2,4.25,19.18,19.18,0,0,0,7,1.29,16.83,16.83,0,0,0,10.62-3.47,11.1,11.1,0,0,0,4.47-9.23,9.51,9.51,0,0,0-2.47-6.44,12.79,12.79,0,0,0-7.25-3.86l-13.28-3a21.57,21.57,0,0,1-12.6-7.56,20.07,20.07,0,0,1-4.59-12.8,21.54,21.54,0,0,1,2.1-9.57,19.38,19.38,0,0,1,5.62-7,26.6,26.6,0,0,1,7.93-4.18A29,29,0,0,1,77,35.22a30.47,30.47,0,0,1,11.06,2,25.26,25.26,0,0,1,9.4,6.47,24.38,24.38,0,0,1,5.76,10.69l-9.72,3.81a16.4,16.4,0,0,0-6.42-9.37,17.52,17.52,0,0,0-10.18-3.22,14.45,14.45,0,0,0-9.33,3.09,10.22,10.22,0,0,0-3.85,8.41,10,10,0,0,0,2.15,6.27,10.13,10.13,0,0,0,6.06,3.68L87,70.46a22.52,22.52,0,0,1,9.44,4.33,19.05,19.05,0,0,1,5.66,7.13,21,21,0,0,1,1.78,8.62,22.41,22.41,0,0,1-1.73,8.62,24.69,24.69,0,0,1-5,7.56,23.17,23.17,0,0,1-8.32,5.45,29.93,29.93,0,0,1-11.26,2,32.58,32.58,0,0,1-11.13-1.93,28.17,28.17,0,0,1-10-6.32A26.33,26.33,0,0,1,49.79,95.32Z",
    transform: "translate(-49.79 -35.22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.87,112.22l29.69-75h12.3l29.69,75h-13l-7.47-19.39H139.28l-7.52,19.39Zm24.42-29.79h22.8L154.66,53Z",
    transform: "translate(-49.79 -35.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.53,112.22v-75h12v64.5H253v10.5Z",
    transform: "translate(-49.79 -35.22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.49,112.22v-75h12v75Z",
    transform: "translate(-49.79 -35.22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.49,112.22l29.1-37.5-29.1-37.5h14.4l21.88,28.22,22-28.22h14.4l-29.1,37.5,29.1,37.5h-14.4L340.77,84l-21.88,28.23Z",
    transform: "translate(-49.79 -35.22)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalixLogoReverse);
export default __webpack_public_path__ + "static/media/SalixLogoReverse.bda2b0d6.svg";
export { ForwardRef as ReactComponent };